import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import { BREAKPOINTS } from '../../lib/constants';
// eslint-disable-next-line import/extensions
import { dotSpacer } from '../../lib/styles/dot-spacer.styles';

export const NetworkAffiliationsSection = styled.div`
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text')};
`;

export const NetworkAffiliationsHeader = styled.strong`
  display: block;
  font-weight: ${fromTheme('font_weight_bold')};
`;

export const NetworkAffiliationsFlexContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
`;

export const NetworkAffiliationsList = styled.ul<{ hasLogos: boolean }>`
  padding: 0;
  margin: ${fromTheme('spacing_small')} 0;
`;

export const NetworkAffiliationsListItem = styled.li<{ hasLogos: boolean }>`
  list-style: none;
  margin: 0 ${fromTheme('spacing_small')} 0 0;
  margin-bottom: ${(props) =>
    props.hasLogos ? fromTheme('spacing_small') : '0'};
  font-size: ${fromTheme('font_size')};
  color: ${fromTheme('color_text')};
  font-weight: ${fromTheme('font_weight')};
  display: inline-block;

  & + li:before {
    ${(props) => dotSpacer({ marginRight: fromTheme('spacing_small')(props) })}
  }

  @media screen and (max-width: ${BREAKPOINTS.small}px) {
    display: block;
    & + li:before {
      display: none;
    }
  }
`;

export const LogosContainer = styled.div`
  margin-top: -${fromTheme('spacing_small')};

  @media screen and (max-width: ${BREAKPOINTS.small}px) {
    margin-top: 0;
  }
`;
